import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { lazy } from 'react';
import { getConf } from '@jbrowse/core/configuration';
import { BaseViewModel } from '@jbrowse/core/pluggableElementTypes/models';
import { ElementId, Region as MUIRegion } from '@jbrowse/core/util/types/mst';
import { ReturnToImportFormDialog } from '@jbrowse/core/ui';
import { assembleLocString, clamp, findLastIndex, getContainingView, getSession, isViewContainer, isSessionModelWithWidgets, isSessionWithAddTracks, localStorageGetItem, measureText, parseLocString, springAnimate } from '@jbrowse/core/util';
import calculateDynamicBlocks from '@jbrowse/core/util/calculateDynamicBlocks';
import calculateStaticBlocks from '@jbrowse/core/util/calculateStaticBlocks';
import { getParentRenderProps } from '@jbrowse/core/util/tracks';
import { when, transaction, autorun } from 'mobx';
import { addDisposer, cast, getSnapshot, getRoot, resolveIdentifier, types } from 'mobx-state-tree';
import Base1DView from '@jbrowse/core/util/Base1DViewModel';
import { moveTo as _moveTo, pxToBp as _pxToBp, bpToPx as _bpToPx } from '@jbrowse/core/util/Base1DUtils';
import { saveAs } from 'file-saver';
import clone from 'clone';
// icons
import { TrackSelector as TrackSelectorIcon } from '@jbrowse/core/ui/Icons';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LabelIcon from '@mui/icons-material/Label';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
// locals
import { renderToSvg } from './svgcomponents/SVGLinearGenomeView';
import RefNameAutocomplete from './components/RefNameAutocomplete';
import SearchBox from './components/SearchBox';
import ExportSvgDlg from './components/ExportSvgDialog';
import MiniControls from './components/MiniControls';
import Header from './components/Header';
import ZoomControls from './components/ZoomControls';
import LinearGenomeView from './components/LinearGenomeView';
// lazies
var SequenceSearchDialog = lazy(function () {
  return import('./components/SequenceSearchDialog');
});
function calculateVisibleLocStrings(contentBlocks) {
  if (!contentBlocks.length) {
    return '';
  }
  var isSingleAssemblyName = contentBlocks.every(function (b) {
    return b.assemblyName === contentBlocks[0].assemblyName;
  });
  var locs = contentBlocks.map(function (block) {
    return assembleLocString(_objectSpread({}, block, {
      start: Math.round(block.start),
      end: Math.round(block.end),
      assemblyName: isSingleAssemblyName ? undefined : block.assemblyName
    }));
  });
  return locs.join(' ');
}
export var HEADER_BAR_HEIGHT = 48;
export var HEADER_OVERVIEW_HEIGHT = 20;
export var SCALE_BAR_HEIGHT = 17;
export var RESIZE_HANDLE_HEIGHT = 3;
export var INTER_REGION_PADDING_WIDTH = 2;
export var SPACING = 7;
export var WIDGET_HEIGHT = 32;
/**
 * #stateModel LinearGenomeView
 */
export function stateModelFactory(pluginManager) {
  return types.compose(BaseViewModel, types.model('LinearGenomeView', {
    /**
     * #property
     */
    id: ElementId,
    /**
     * #property
     * this is a string instead of the const literal 'LinearGenomeView' to
     * reduce some typescripting strictness, but you should pass the string
     * 'LinearGenomeView' to the model explicitly
     */
    type: types.literal('LinearGenomeView'),
    /**
     * #property
     * corresponds roughly to the horizontal scroll of the LGV
     */
    offsetPx: 0,
    /**
     * #property
     * corresponds roughly to the zoom level, base-pairs per pixel
     */
    bpPerPx: 1,
    /**
     * #property
     * currently displayed regions, can be a single chromosome, arbitrary
     * subsections, or the entire  set of chromosomes in the genome, but it not
     * advised to use the entire set of chromosomes if your assembly is very
     * fragmented
     */
    displayedRegions: types.array(MUIRegion),
    /**
     * #property
     * array of currently displayed tracks state models instances
     */
    tracks: types.array(pluginManager.pluggableMstType('track', 'stateModel')),
    /**
     * #property
     * array of currently displayed tracks state model's
     */
    hideHeader: false,
    /**
     * #property
     */
    hideHeaderOverview: false,
    /**
     * #property
     */
    hideNoTracksActive: false,
    /**
     * #property
     */
    trackSelectorType: types.optional(types.enumeration(['hierarchical']), 'hierarchical'),
    /**
     * #property
     * how to display the track labels, can be "overlapping", "offset", or "hidden"
     */
    trackLabels: types.optional(types.string, function () {
      return localStorageGetItem('lgv-trackLabels') || 'overlapping';
    }),
    /**
     * #property
     * show the "center line"
     */
    showCenterLine: types.optional(types.boolean, function () {
      return Boolean(JSON.parse(localStorageGetItem('lgv-showCenterLine') || 'false'));
    }),
    /**
     * #property
     * show the "cytobands" in the overview scale bar
     */
    showCytobandsSetting: types.optional(types.boolean, function () {
      return Boolean(JSON.parse(localStorageGetItem('lgv-showCytobands') || 'true'));
    }),
    /**
     * #property
     * show the "gridlines" in the track area
     */
    showGridlines: true
  })).volatile(function () {
    return {
      volatileWidth: undefined,
      minimumBlockWidth: 3,
      draggingTrackId: undefined,
      volatileError: undefined,
      // array of callbacks to run after the next set of the displayedRegions,
      // which is basically like an onLoad
      afterDisplayedRegionsSetCallbacks: [],
      scaleFactor: 1,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      trackRefs: {},
      coarseDynamicBlocks: [],
      coarseTotalBp: 0,
      leftOffset: undefined,
      rightOffset: undefined,
      searchResults: undefined,
      searchQuery: undefined,
      seqDialogDisplayed: false
    };
  }).views(function (self) {
    return {
      /**
       * #getter
       */
      get width() {
        if (self.volatileWidth === undefined) {
          throw new Error('width undefined, make sure to check for model.initialized');
        }
        return self.volatileWidth;
      },
      /**
       * #getter
       */
      get interRegionPaddingWidth() {
        return INTER_REGION_PADDING_WIDTH;
      },
      /**
       * #getter
       */
      get assemblyNames() {
        return _toConsumableArray(new Set(self.displayedRegions.map(function (region) {
          return region.assemblyName;
        })));
      }
    };
  }).views(function (self) {
    return {
      /**
       * #method
       */
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      MiniControlsComponent: function MiniControlsComponent() {
        return MiniControls;
      },
      /**
       * #method
       */
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      HeaderComponent: function HeaderComponent() {
        return Header;
      },
      /**
       * #getter
       */
      get assemblyErrors() {
        var _getSession = getSession(self),
          assemblyManager = _getSession.assemblyManager;
        var assemblyNames = self.assemblyNames;
        return assemblyNames.map(function (a) {
          var _a;
          return (_a = assemblyManager.get(a)) === null || _a === void 0 ? void 0 : _a.error;
        }).filter(function (f) {
          return !!f;
        }).join(', ');
      },
      /**
       * #getter
       */
      get assembliesInitialized() {
        var _getSession2 = getSession(self),
          assemblyManager = _getSession2.assemblyManager;
        var assemblyNames = self.assemblyNames;
        return assemblyNames.every(function (a) {
          var _a;
          return (_a = assemblyManager.get(a)) === null || _a === void 0 ? void 0 : _a.initialized;
        });
      },
      /**
       * #getter
       */
      get initialized() {
        return self.volatileWidth !== undefined && this.assembliesInitialized;
      },
      /**
       * #getter
       */
      get hasDisplayedRegions() {
        return self.displayedRegions.length > 0;
      },
      /**
       * #getter
       */
      get isSearchDialogDisplayed() {
        return self.searchResults !== undefined;
      },
      /**
       * #getter
       */
      get scaleBarHeight() {
        return SCALE_BAR_HEIGHT + RESIZE_HANDLE_HEIGHT;
      },
      /**
       * #getter
       */
      get headerHeight() {
        if (self.hideHeader) {
          return 0;
        }
        if (self.hideHeaderOverview) {
          return HEADER_BAR_HEIGHT;
        }
        return HEADER_BAR_HEIGHT + HEADER_OVERVIEW_HEIGHT;
      },
      /**
       * #getter
       */
      get trackHeights() {
        return self.tracks.map(function (t) {
          return t.displays[0].height;
        }).reduce(function (a, b) {
          return a + b;
        }, 0);
      },
      /**
       * #getter
       */
      get trackHeightsWithResizeHandles() {
        return this.trackHeights + self.tracks.length * RESIZE_HANDLE_HEIGHT;
      },
      /**
       * #getter
       */
      get height() {
        return this.trackHeightsWithResizeHandles + this.headerHeight + this.scaleBarHeight;
      },
      /**
       * #getter
       */
      get totalBp() {
        return self.displayedRegions.reduce(function (a, b) {
          return a + b.end - b.start;
        }, 0);
      },
      /**
       * #getter
       */
      get maxBpPerPx() {
        return this.totalBp / (self.width * 0.9);
      },
      /**
       * #getter
       */
      get minBpPerPx() {
        return 1 / 50;
      },
      /**
       * #getter
       */
      get error() {
        return self.volatileError || this.assemblyErrors;
      },
      /**
       * #getter
       */
      get maxOffset() {
        // objectively determined to keep the linear genome on the main screen
        var leftPadding = 10;
        return this.displayedRegionsTotalPx - leftPadding;
      },
      /**
       * #getter
       */
      get minOffset() {
        // objectively determined to keep the linear genome on the main screen
        var rightPadding = 30;
        return -self.width + rightPadding;
      },
      /**
       * #getter
       */
      get displayedRegionsTotalPx() {
        return this.totalBp / self.bpPerPx;
      },
      /**
       * #method
       */
      renderProps: function renderProps() {
        return _objectSpread({}, getParentRenderProps(self), {
          bpPerPx: self.bpPerPx,
          highResolutionScaling: getConf(getSession(self), 'highResolutionScaling')
        });
      },
      /**
       * #method
       */
      searchScope: function searchScope(assemblyName) {
        return {
          assemblyName: assemblyName,
          includeAggregateIndexes: true,
          tracks: self.tracks
        };
      },
      /**
       * #method
       */
      getTrack: function getTrack(id) {
        return self.tracks.find(function (t) {
          return t.configuration.trackId === id;
        });
      },
      /**
       * #method
       */
      rankSearchResults: function rankSearchResults(results) {
        // order of rank
        var openTrackIds = self.tracks.map(function (track) {
          return track.configuration.trackId;
        });
        results.forEach(function (result) {
          if (openTrackIds.includes(result.trackId)) {
            result.updateScore(result.getScore() + 1);
          }
        });
        return results;
      },
      /**
       * #method
       * modifies view menu action onClick to apply to all tracks of same type
       */
      rewriteOnClicks: function rewriteOnClicks(trackType, viewMenuActions) {
        var _this = this;
        viewMenuActions.forEach(function (action) {
          // go to lowest level menu
          if ('subMenu' in action) {
            _this.rewriteOnClicks(trackType, action.subMenu);
          }
          if ('onClick' in action) {
            var holdOnClick = action.onClick;
            action.onClick = function () {
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              self.tracks.forEach(function (track) {
                if (track.type === trackType) {
                  holdOnClick.apply(track, [track].concat(args));
                }
              });
            };
          }
        });
      },
      /**
       * #getter
       */
      get trackTypeActions() {
        var _this2 = this;
        var allActions = new Map();
        self.tracks.forEach(function (track) {
          var trackInMap = allActions.get(track.type);
          if (!trackInMap) {
            var viewMenuActions = clone(track.viewMenuActions);
            _this2.rewriteOnClicks(track.type, viewMenuActions);
            allActions.set(track.type, viewMenuActions);
          }
        });
        return allActions;
      }
    };
  }).actions(function (self) {
    return {
      /**
       * #action
       */
      setShowCytobands: function setShowCytobands(flag) {
        self.showCytobandsSetting = flag;
      },
      /**
       * #action
       */
      setWidth: function setWidth(newWidth) {
        self.volatileWidth = newWidth;
      },
      /**
       * #action
       */
      setError: function setError(error) {
        self.volatileError = error;
      },
      /**
       * #action
       */
      toggleHeader: function toggleHeader() {
        self.hideHeader = !self.hideHeader;
      },
      /**
       * #action
       */
      toggleHeaderOverview: function toggleHeaderOverview() {
        self.hideHeaderOverview = !self.hideHeaderOverview;
      },
      /**
       * #action
       */
      toggleNoTracksActive: function toggleNoTracksActive() {
        self.hideNoTracksActive = !self.hideNoTracksActive;
      },
      /**
       * #action
       */
      toggleShowGridlines: function toggleShowGridlines() {
        self.showGridlines = !self.showGridlines;
      },
      /**
       * #action
       */
      scrollTo: function scrollTo(offsetPx) {
        var newOffsetPx = clamp(offsetPx, self.minOffset, self.maxOffset);
        self.offsetPx = newOffsetPx;
        return newOffsetPx;
      },
      /**
       * #action
       */
      zoomTo: function zoomTo(bpPerPx) {
        var newBpPerPx = clamp(bpPerPx, self.minBpPerPx, self.maxBpPerPx);
        if (newBpPerPx === self.bpPerPx) {
          return newBpPerPx;
        }
        var oldBpPerPx = self.bpPerPx;
        self.bpPerPx = newBpPerPx;
        if (Math.abs(oldBpPerPx - newBpPerPx) < 0.000001) {
          console.warn('zoomTo bpPerPx rounding error');
          return oldBpPerPx;
        }
        // tweak the offset so that the center of the view remains at the same coordinate
        var viewWidth = self.width;
        this.scrollTo(Math.round((self.offsetPx + viewWidth / 2) * oldBpPerPx / newBpPerPx - viewWidth / 2));
        return newBpPerPx;
      },
      /**
       * #action
       * sets offsets used in the get sequence dialog
       */
      setOffsets: function setOffsets(left, right) {
        self.leftOffset = left;
        self.rightOffset = right;
      },
      /**
       * #action
       */
      setSearchResults: function setSearchResults(results, query) {
        self.searchResults = results;
        self.searchQuery = query;
      },
      /**
       * #action
       */
      setGetSequenceDialogOpen: function setGetSequenceDialogOpen(open) {
        self.seqDialogDisplayed = open;
      },
      /**
       * #action
       */
      setNewView: function setNewView(bpPerPx, offsetPx) {
        this.zoomTo(bpPerPx);
        this.scrollTo(offsetPx);
      },
      /**
       * #action
       */
      horizontallyFlip: function horizontallyFlip() {
        self.displayedRegions = cast(self.displayedRegions.slice().reverse().map(function (region) {
          return _objectSpread({}, region, {
            reversed: !region.reversed
          });
        }));
        this.scrollTo(self.totalBp / self.bpPerPx - self.offsetPx - self.width);
      },
      /**
       * #action
       */
      showTrack: function showTrack(trackId) {
        var initialSnapshot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var displayInitialSnapshot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var schema = pluginManager.pluggableConfigSchemaType('track');
        var conf = resolveIdentifier(schema, getRoot(self), trackId);
        if (!conf) {
          throw new Error("Could not resolve identifier \"".concat(trackId, "\""));
        }
        var trackType = pluginManager.getTrackType(conf === null || conf === void 0 ? void 0 : conf.type);
        if (!trackType) {
          throw new Error("Unknown track type ".concat(conf.type));
        }
        var viewType = pluginManager.getViewType(self.type);
        var supportedDisplays = viewType.displayTypes.map(function (d) {
          return d.name;
        });
        var displayConf = conf.displays.find(function (d) {
          return supportedDisplays.includes(d.type);
        });
        if (!displayConf) {
          throw new Error("Could not find a compatible display for view type ".concat(self.type));
        }
        var t = self.tracks.filter(function (t) {
          return t.configuration === conf;
        });
        if (t.length === 0) {
          var track = trackType.stateModel.create(_objectSpread({}, initialSnapshot, {
            type: conf.type,
            configuration: conf,
            displays: [_objectSpread({
              type: displayConf.type,
              configuration: displayConf
            }, displayInitialSnapshot)]
          }));
          self.tracks.push(track);
          return track;
        }
        return t[0];
      },
      /**
       * #action
       */
      hideTrack: function hideTrack(trackId) {
        var schema = pluginManager.pluggableConfigSchemaType('track');
        var conf = resolveIdentifier(schema, getRoot(self), trackId);
        var t = self.tracks.filter(function (t) {
          return t.configuration === conf;
        });
        transaction(function () {
          return t.forEach(function (t) {
            return self.tracks.remove(t);
          });
        });
        return t.length;
      }
    };
  }).actions(function (self) {
    return {
      /**
       * #action
       */
      moveTrack: function moveTrack(movingId, targetId) {
        var oldIndex = self.tracks.findIndex(function (track) {
          return track.id === movingId;
        });
        if (oldIndex === -1) {
          throw new Error("Track ID ".concat(movingId, " not found"));
        }
        var newIndex = self.tracks.findIndex(function (track) {
          return track.id === targetId;
        });
        if (newIndex === -1) {
          throw new Error("Track ID ".concat(targetId, " not found"));
        }
        var track = getSnapshot(self.tracks[oldIndex]);
        self.tracks.splice(oldIndex, 1);
        self.tracks.splice(newIndex, 0, track);
      },
      /**
       * #action
       */
      closeView: function closeView() {
        var parent = getContainingView(self);
        if (parent) {
          // I am embedded in a some other view
          if (isViewContainer(parent)) {
            parent.removeView(self);
          }
        } else {
          // I am part of a session
          getSession(self).removeView(self);
        }
      },
      /**
       * #action
       */
      toggleTrack: function toggleTrack(trackId) {
        // if we have any tracks with that configuration, turn them off
        var hiddenCount = self.hideTrack(trackId);
        // if none had that configuration, turn one on
        if (!hiddenCount) {
          self.showTrack(trackId);
        }
      },
      /**
       * #action
       */
      setTrackLabels: function setTrackLabels(setting) {
        self.trackLabels = setting;
      },
      /**
       * #action
       */
      toggleCenterLine: function toggleCenterLine() {
        self.showCenterLine = !self.showCenterLine;
      },
      /**
       * #action
       */
      setDisplayedRegions: function setDisplayedRegions(regions) {
        self.displayedRegions = cast(regions);
        self.zoomTo(self.bpPerPx);
      },
      /**
       * #action
       */
      activateTrackSelector: function activateTrackSelector() {
        if (self.trackSelectorType === 'hierarchical') {
          var session = getSession(self);
          if (isSessionModelWithWidgets(session)) {
            var selector = session.addWidget('HierarchicalTrackSelectorWidget', 'hierarchicalTrackSelector', {
              view: self
            });
            session.showWidget(selector);
            return selector;
          }
        }
        throw new Error("invalid track selector type ".concat(self.trackSelectorType));
      },
      /**
       * #method
       * Helper method for the fetchSequence.
       * Retrieves the corresponding regions that were selected by the rubberband
       *
       * @param leftOffset - `object as {start, end, index, offset}`, offset = start of user drag
       * @param rightOffset - `object as {start, end, index, offset}`, offset = end of user drag
       * @returns array of Region[]
       */
      getSelectedRegions: function getSelectedRegions(leftOffset, rightOffset) {
        var snap = getSnapshot(self);
        var simView = Base1DView.create(_objectSpread({}, snap, {
          interRegionPaddingWidth: self.interRegionPaddingWidth
        }));
        simView.setVolatileWidth(self.width);
        simView.moveTo(leftOffset, rightOffset);
        return simView.dynamicBlocks.contentBlocks.map(function (region) {
          return _objectSpread({}, region, {
            start: Math.floor(region.start),
            end: Math.ceil(region.end)
          });
        });
      },
      /**
       * #action
       * schedule something to be run after the next time displayedRegions is set
       */
      afterDisplayedRegionsSet: function afterDisplayedRegionsSet(cb) {
        self.afterDisplayedRegionsSetCallbacks.push(cb);
      },
      /**
       * #action
       */
      horizontalScroll: function horizontalScroll(distance) {
        var oldOffsetPx = self.offsetPx;
        // newOffsetPx is the actual offset after the scroll is clamped
        var newOffsetPx = self.scrollTo(self.offsetPx + distance);
        return newOffsetPx - oldOffsetPx;
      },
      /**
       * #action
       */
      center: function center() {
        var centerBp = self.totalBp / 2;
        var centerPx = centerBp / self.bpPerPx;
        self.scrollTo(Math.round(centerPx - self.width / 2));
      },
      /**
       * #action
       */
      showAllRegions: function showAllRegions() {
        self.zoomTo(self.maxBpPerPx);
        this.center();
      },
      /**
       * #action
       */
      showAllRegionsInAssembly: function showAllRegionsInAssembly(assemblyName) {
        var session = getSession(self);
        var assemblyManager = session.assemblyManager;
        if (!assemblyName) {
          var names = new Set(self.displayedRegions.map(function (r) {
            return r.assemblyName;
          }));
          if (names.size > 1) {
            session.notify("Can't perform operation with multiple assemblies currently");
            return;
          }
          ;
          var _ref = _toConsumableArray(names);
          assemblyName = _ref[0];
        }
        var assembly = assemblyManager.get(assemblyName);
        if (assembly) {
          var regions = assembly.regions;
          if (regions) {
            this.setDisplayedRegions(regions);
            self.zoomTo(self.maxBpPerPx);
            this.center();
          }
        }
      },
      /**
       * #action
       */
      setDraggingTrackId: function setDraggingTrackId(idx) {
        self.draggingTrackId = idx;
      },
      /**
       * #action
       */
      setScaleFactor: function setScaleFactor(factor) {
        self.scaleFactor = factor;
      },
      /**
       * #action
       * this "clears the view" and makes the view return to the import form
       */
      clearView: function clearView() {
        this.setDisplayedRegions([]);
        self.tracks.clear();
        // it is necessary to run these after setting displayed regions empty
        // or else model.offsetPx gets set to Infinity and breaks
        // mobx-state-tree snapshot
        self.scrollTo(0);
        self.zoomTo(10);
      },
      /**
       * #method
       * creates an svg export and save using FileSaver
       */
      exportSvg: function () {
        var _exportSvg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var opts,
            html,
            blob,
            _args = arguments;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                opts = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                _context.next = 3;
                return renderToSvg(self, opts);
              case 3:
                html = _context.sent;
                blob = new Blob([html], {
                  type: 'image/svg+xml'
                });
                saveAs(blob, opts.filename || 'image.svg');
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function exportSvg() {
          return _exportSvg.apply(this, arguments);
        }
        return exportSvg;
      }()
    };
  }).actions(function (self) {
    var cancelLastAnimation = function cancelLastAnimation() {};
    /**
     * #action
     * perform animated slide
     */
    function slide(viewWidths) {
      var _springAnimate = springAnimate(self.offsetPx, self.offsetPx + self.width * viewWidths, self.scrollTo),
        _springAnimate2 = _slicedToArray(_springAnimate, 2),
        animate = _springAnimate2[0],
        cancelAnimation = _springAnimate2[1];
      cancelLastAnimation();
      cancelLastAnimation = cancelAnimation;
      animate();
    }
    return {
      slide: slide
    };
  }).actions(function (self) {
    var cancelLastAnimation = function cancelLastAnimation() {};
    /**
     * #action
     * perform animated zoom
     */
    function zoom(targetBpPerPx) {
      self.zoomTo(self.bpPerPx);
      if (
      // already zoomed all the way in
      targetBpPerPx < self.bpPerPx && self.bpPerPx === self.minBpPerPx ||
      // already zoomed all the way out
      targetBpPerPx > self.bpPerPx && self.bpPerPx === self.maxBpPerPx) {
        return;
      }
      var factor = self.bpPerPx / targetBpPerPx;
      var _springAnimate3 = springAnimate(1, factor, self.setScaleFactor, function () {
          self.zoomTo(targetBpPerPx);
          self.setScaleFactor(1);
        }),
        _springAnimate4 = _slicedToArray(_springAnimate3, 2),
        animate = _springAnimate4[0],
        cancelAnimation = _springAnimate4[1];
      cancelLastAnimation();
      cancelLastAnimation = cancelAnimation;
      animate();
    }
    return {
      zoom: zoom
    };
  }).views(function (self) {
    return {
      /**
       * #getter
       */
      get canShowCytobands() {
        return self.displayedRegions.length === 1 && this.anyCytobandsExist;
      },
      /**
       * #getter
       */
      get showCytobands() {
        return this.canShowCytobands && self.showCytobandsSetting;
      },
      /**
       * #getter
       */
      get anyCytobandsExist() {
        var _getSession3 = getSession(self),
          assemblyManager = _getSession3.assemblyManager;
        return self.assemblyNames.some(function (a) {
          var _a, _b;
          return (_b = (_a = assemblyManager.get(a)) === null || _a === void 0 ? void 0 : _a.cytobands) === null || _b === void 0 ? void 0 : _b.length;
        });
      },
      /**
       * #getter
       * the cytoband is displayed to the right of the chromosome name,
       * and that offset is calculated manually with this method
       */
      get cytobandOffset() {
        return this.showCytobands ? measureText(self.displayedRegions[0].refName, 12) + 15 : 0;
      }
    };
  }).views(function (self) {
    return {
      /**
       * #method
       * return the view menu items
       */
      menuItems: function menuItems() {
        var canShowCytobands = self.canShowCytobands,
          showCytobands = self.showCytobands;
        var session = getSession(self);
        var menuItems = [{
          label: 'Return to import form',
          onClick: function onClick() {
            getSession(self).queueDialog(function (handleClose) {
              return [ReturnToImportFormDialog, {
                model: self,
                handleClose: handleClose
              }];
            });
          },
          icon: FolderOpenIcon
        }].concat(_toConsumableArray(isSessionWithAddTracks(session) ? [{
          label: 'Sequence search',
          onClick: function onClick() {
            getSession(self).queueDialog(function (handleClose) {
              return [SequenceSearchDialog, {
                model: self,
                handleClose: handleClose
              }];
            });
          }
        }] : []), [{
          label: 'Export SVG',
          icon: PhotoCameraIcon,
          onClick: function onClick() {
            getSession(self).queueDialog(function (handleClose) {
              return [ExportSvgDlg, {
                model: self,
                handleClose: handleClose
              }];
            });
          }
        }, {
          label: 'Open track selector',
          onClick: self.activateTrackSelector,
          icon: TrackSelectorIcon
        }, {
          label: 'Horizontally flip',
          icon: SyncAltIcon,
          onClick: self.horizontallyFlip
        }, {
          label: 'Show...',
          icon: VisibilityIcon,
          subMenu: [{
            label: 'Show all regions in assembly',
            onClick: self.showAllRegionsInAssembly
          }, {
            label: 'Show center line',
            type: 'checkbox',
            checked: self.showCenterLine,
            onClick: self.toggleCenterLine
          }, {
            label: 'Show header',
            type: 'checkbox',
            checked: !self.hideHeader,
            onClick: self.toggleHeader
          }, {
            label: 'Show header overview',
            type: 'checkbox',
            checked: !self.hideHeaderOverview,
            onClick: self.toggleHeaderOverview,
            disabled: self.hideHeader
          }, {
            label: 'Show no tracks active button',
            type: 'checkbox',
            checked: !self.hideNoTracksActive,
            onClick: self.toggleNoTracksActive
          }, {
            label: 'Show guidelines',
            type: 'checkbox',
            checked: self.showGridlines,
            onClick: self.toggleShowGridlines
          }].concat(_toConsumableArray(canShowCytobands ? [{
            label: 'Show ideogram',
            type: 'checkbox',
            checked: self.showCytobands,
            onClick: function onClick() {
              return self.setShowCytobands(!showCytobands);
            }
          }] : []))
        }, {
          label: 'Track labels',
          icon: LabelIcon,
          subMenu: [{
            label: 'Overlapping',
            icon: VisibilityIcon,
            type: 'radio',
            checked: self.trackLabels === 'overlapping',
            onClick: function onClick() {
              return self.setTrackLabels('overlapping');
            }
          }, {
            label: 'Offset',
            icon: VisibilityIcon,
            type: 'radio',
            checked: self.trackLabels === 'offset',
            onClick: function onClick() {
              return self.setTrackLabels('offset');
            }
          }, {
            label: 'Hidden',
            icon: VisibilityIcon,
            type: 'radio',
            checked: self.trackLabels === 'hidden',
            onClick: function onClick() {
              return self.setTrackLabels('hidden');
            }
          }]
        }]);
        // add track's view level menu options
        var _iterator = _createForOfIteratorHelper(self.trackTypeActions.entries()),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];
            if (value.length) {
              menuItems.push({
                type: 'divider'
              }, {
                type: 'subHeader',
                label: key
              });
              value.forEach(function (action) {
                return menuItems.push(action);
              });
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return menuItems;
      }
    };
  }).views(function (self) {
    var currentlyCalculatedStaticBlocks;
    var stringifiedCurrentlyCalculatedStaticBlocks = '';
    return {
      /**
       * #getter
       * static blocks are an important concept jbrowse uses to avoid
       * re-rendering when you scroll to the side. when you horizontally
       * scroll to the right, old blocks to the left may be removed, and
       * new blocks may be instantiated on the right. tracks may use the
       * static blocks to render their data for the region represented by
       * the block
       */
      get staticBlocks() {
        var ret = calculateStaticBlocks(self);
        var sret = JSON.stringify(ret);
        if (stringifiedCurrentlyCalculatedStaticBlocks !== sret) {
          currentlyCalculatedStaticBlocks = ret;
          stringifiedCurrentlyCalculatedStaticBlocks = sret;
        }
        return currentlyCalculatedStaticBlocks;
      },
      /**
       * #getter
       * dynamic blocks represent the exact coordinates of the currently
       * visible genome regions on the screen. they are similar to static
       * blocks, but statcic blocks can go offscreen while dynamic blocks
       * represent exactly what is on screen
       */
      get dynamicBlocks() {
        return calculateDynamicBlocks(self);
      },
      /**
       * #getter
       * rounded dynamic blocks are dynamic blocks without fractions of bp
       */
      get roundedDynamicBlocks() {
        return this.dynamicBlocks.contentBlocks.map(function (block) {
          return _objectSpread({}, block, {
            start: Math.floor(block.start),
            end: Math.ceil(block.end)
          });
        });
      },
      /**
       * #getter
       * a single "combo-locstring" representing all the regions visible
       * on the screen
       */
      get visibleLocStrings() {
        return calculateVisibleLocStrings(this.dynamicBlocks.contentBlocks);
      },
      /**
       * #getter
       * same as visibleLocStrings, but only updated every 300ms
       */
      get coarseVisibleLocStrings() {
        return calculateVisibleLocStrings(self.coarseDynamicBlocks);
      }
    };
  }).actions(function (self) {
    return {
      /**
       * #action
       */
      setCoarseDynamicBlocks: function setCoarseDynamicBlocks(blocks) {
        self.coarseDynamicBlocks = blocks.contentBlocks;
        self.coarseTotalBp = blocks.totalBp;
      },
      afterAttach: function afterAttach() {
        var _this3 = this;
        addDisposer(self, autorun(function () {
          if (self.initialized) {
            _this3.setCoarseDynamicBlocks(self.dynamicBlocks);
          }
        }, {
          delay: 150
        }));
        addDisposer(self, autorun(function () {
          var s = function s(_s) {
            return JSON.stringify(_s);
          };
          var trackLabels = self.trackLabels,
            showCytobandsSetting = self.showCytobandsSetting,
            showCenterLine = self.showCenterLine;
          if (typeof localStorage !== 'undefined') {
            localStorage.setItem('lgv-trackLabels', trackLabels);
            localStorage.setItem('lgv-showCytobands', s(showCytobandsSetting));
            localStorage.setItem('lgv-showCenterLine', s(showCenterLine));
          }
        }));
      }
    };
  }).actions(function (self) {
    return {
      /**
       * #action
       * offset is the base-pair-offset in the displayed region, index is the index of the
       * displayed region in the linear genome view
       *
       * @param start - object as `{start, end, offset, index}`
       * @param end - object as `{start, end, offset, index}`
       */
      moveTo: function moveTo(start, end) {
        _moveTo(self, start, end);
      },
      /**
       * #action
       * navigate to the given locstring
       *
       * @param locString - e.g. "chr1:1-100"
       * @param optAssemblyName - (optional) the assembly name to use when navigating to the locstring
       */
      navToLocString: function () {
        var _navToLocString = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(locString, optAssemblyName) {
          var assemblyNames, _getSession4, assemblyManager, isValidRefName, assemblyName, parsedLocStrings, inputs, _inputs, refName, start, end, locations, loc, _start, _end, parentRegion;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                assemblyNames = self.assemblyNames;
                _getSession4 = getSession(self), assemblyManager = _getSession4.assemblyManager;
                isValidRefName = assemblyManager.isValidRefName;
                _context3.next = 5;
                return when(function () {
                  return self.volatileWidth !== undefined;
                });
              case 5:
                assemblyName = optAssemblyName || assemblyNames[0];
                inputs = locString.split(/(\s+)/).map(function (f) {
                  return f.trim();
                }).filter(function (f) {
                  return !!f;
                });
                if (!assemblyName) {
                  _context3.next = 10;
                  break;
                }
                _context3.next = 10;
                return assemblyManager.waitForAssembly(assemblyName);
              case 10:
                _context3.prev = 10;
                parsedLocStrings = inputs.map(function (loc) {
                  return parseLocString(loc, function (ref) {
                    return isValidRefName(ref, assemblyName);
                  });
                });
                _context3.next = 22;
                break;
              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](10);
                // if this fails, try interpreting as a whitespace-separated refname,
                // start, end if start and end are integer inputs
                _inputs = _slicedToArray(inputs, 3), refName = _inputs[0], start = _inputs[1], end = _inputs[2];
                if (!("".concat(_context3.t0).match(/Unknown reference sequence/) && Number.isInteger(+start) && Number.isInteger(+end))) {
                  _context3.next = 21;
                  break;
                }
                parsedLocStrings = [parseLocString(refName + ':' + start + '..' + end, function (ref) {
                  return isValidRefName(ref, assemblyName);
                })];
                _context3.next = 22;
                break;
              case 21:
                throw _context3.t0;
              case 22:
                _context3.next = 24;
                return Promise.all(parsedLocStrings === null || parsedLocStrings === void 0 ? void 0 : parsedLocStrings.map( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(region) {
                    var asmName, asm, refName, regions, canonicalRefName, parentRegion;
                    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                      while (1) switch (_context2.prev = _context2.next) {
                        case 0:
                          asmName = region.assemblyName || assemblyName;
                          _context2.next = 3;
                          return assemblyManager.waitForAssembly(asmName);
                        case 3:
                          asm = _context2.sent;
                          refName = region.refName;
                          if (asm) {
                            _context2.next = 7;
                            break;
                          }
                          throw new Error("assembly ".concat(asmName, " not found"));
                        case 7:
                          regions = asm.regions;
                          if (regions) {
                            _context2.next = 10;
                            break;
                          }
                          throw new Error("regions not loaded yet for ".concat(asmName));
                        case 10:
                          canonicalRefName = asm.getCanonicalRefName(region.refName);
                          if (canonicalRefName) {
                            _context2.next = 13;
                            break;
                          }
                          throw new Error("Could not find refName ".concat(refName, " in ").concat(asm.name));
                        case 13:
                          parentRegion = regions.find(function (r) {
                            return r.refName === canonicalRefName;
                          });
                          if (parentRegion) {
                            _context2.next = 16;
                            break;
                          }
                          throw new Error("Could not find refName ".concat(refName, " in ").concat(asmName));
                        case 16:
                          return _context2.abrupt("return", _objectSpread({}, region, {
                            assemblyName: asmName,
                            parentRegion: parentRegion
                          }));
                        case 17:
                        case "end":
                          return _context2.stop();
                      }
                    }, _callee2);
                  }));
                  return function (_x3) {
                    return _ref2.apply(this, arguments);
                  };
                }()));
              case 24:
                locations = _context3.sent;
                if (locations.length === 1) {
                  loc = locations[0];
                  self.setDisplayedRegions([_objectSpread({
                    reversed: loc.reversed
                  }, loc.parentRegion)]);
                  _start = loc.start, _end = loc.end, parentRegion = loc.parentRegion;
                  this.navTo(_objectSpread({}, loc, {
                    start: clamp(_start !== null && _start !== void 0 ? _start : 0, 0, parentRegion.end),
                    end: clamp(_end !== null && _end !== void 0 ? _end : parentRegion.end, 0, parentRegion.end)
                  }));
                } else {
                  self.setDisplayedRegions(
                  // @ts-ignore
                  locations.map(function (r) {
                    return r.start === undefined ? r.parentRegion : r;
                  }));
                  self.showAllRegions();
                }
              case 26:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this, [[10, 14]]);
        }));
        function navToLocString(_x, _x2) {
          return _navToLocString.apply(this, arguments);
        }
        return navToLocString;
      }(),
      /**
       * #action
       * Navigate to a location based on its refName and optionally start, end,
       * and assemblyName. Can handle if there are multiple displayedRegions
       * from same refName. Only navigates to a location if it is entirely
       * within a displayedRegion. Navigates to the first matching location
       * encountered.
       *
       * Throws an error if navigation was unsuccessful
       *
       * @param query - a proposed location to navigate to
       */
      navTo: function navTo(query) {
        this.navToMultiple([query]);
      },
      /**
       * #action
       */
      navToMultiple: function navToMultiple(locations) {
        var firstLocation = locations[0];
        var refName = firstLocation.refName;
        var start = firstLocation.start,
          end = firstLocation.end,
          _firstLocation$assemb = firstLocation.assemblyName,
          assemblyName = _firstLocation$assemb === void 0 ? self.assemblyNames[0] : _firstLocation$assemb;
        if (start !== undefined && end !== undefined && start > end) {
          throw new Error("start \"".concat(start + 1, "\" is greater than end \"").concat(end, "\""));
        }
        var session = getSession(self);
        var assemblyManager = session.assemblyManager;
        var assembly = assemblyManager.get(assemblyName);
        if (assembly) {
          var canonicalRefName = assembly.getCanonicalRefName(refName);
          if (canonicalRefName) {
            refName = canonicalRefName;
          }
        }
        var s = start;
        var e = end;
        var refNameMatched = false;
        var predicate = function predicate(r) {
          if (refName === r.refName) {
            refNameMatched = true;
            if (s === undefined) {
              s = r.start;
            }
            if (e === undefined) {
              e = r.end;
            }
            if (s >= r.start && s <= r.end && e <= r.end && e >= r.start) {
              return true;
            }
            s = start;
            e = end;
          }
          return false;
        };
        var lastIndex = findLastIndex(self.displayedRegions, predicate);
        var index;
        while (index !== lastIndex) {
          try {
            var previousIndex = index;
            index = self.displayedRegions.slice(previousIndex === undefined ? 0 : previousIndex + 1).findIndex(predicate);
            if (previousIndex !== undefined) {
              index += previousIndex + 1;
            }
            if (!refNameMatched) {
              throw new Error("could not find a region with refName \"".concat(refName, "\""));
            }
            if (s === undefined) {
              throw new Error("could not find a region with refName \"".concat(refName, "\" that contained an end position ").concat(e));
            }
            if (e === undefined) {
              throw new Error("could not find a region with refName \"".concat(refName, "\" that contained a start position ").concat(s + 1));
            }
            if (index === -1) {
              throw new Error("could not find a region that completely contained \"".concat(assembleLocString(firstLocation), "\""));
            }
            if (locations.length === 1) {
              var f = self.displayedRegions[index];
              this.moveTo({
                index: index,
                offset: f.reversed ? f.end - e : s - f.start
              }, {
                index: index,
                offset: f.reversed ? f.end - s : e - f.start
              });
              return;
            }
            var idx = 0;
            var _start2 = 0;
            var _end2 = 0;
            for (idx; idx < locations.length; idx++) {
              var location = locations[idx];
              var region = self.displayedRegions[index + idx];
              _start2 = location.start || region.start;
              _end2 = location.end || region.end;
              if (location.refName !== region.refName) {
                throw new Error("Entered location ".concat(assembleLocString(location), " does not match with displayed regions"));
              }
            }
            idx -= 1;
            var startDisplayedRegion = self.displayedRegions[index];
            var endDisplayedRegion = self.displayedRegions[index + idx];
            this.moveTo({
              index: index,
              offset: startDisplayedRegion.reversed ? startDisplayedRegion.end - e : s - startDisplayedRegion.start
            }, {
              index: index + idx,
              offset: endDisplayedRegion.reversed ? endDisplayedRegion.end - _start2 : _end2 - endDisplayedRegion.start
            });
            return;
          } catch (error) {
            if (index === lastIndex) {
              throw error;
            }
          }
        }
      }
    };
  }).views(function (self) {
    return {
      /**
       * #method
       */
      rubberBandMenuItems: function rubberBandMenuItems() {
        return [{
          label: 'Zoom to region',
          icon: ZoomInIcon,
          onClick: function onClick() {
            var leftOffset = self.leftOffset,
              rightOffset = self.rightOffset;
            self.moveTo(leftOffset, rightOffset);
          }
        }, {
          label: 'Get sequence',
          icon: MenuOpenIcon,
          onClick: function onClick() {
            return self.setGetSequenceDialogOpen(true);
          }
        }];
      },
      /**
       * #method
       */
      bpToPx: function bpToPx(_ref3) {
        var refName = _ref3.refName,
          coord = _ref3.coord,
          regionNumber = _ref3.regionNumber;
        return _bpToPx({
          refName: refName,
          coord: coord,
          regionNumber: regionNumber,
          self: self
        });
      },
      /**
       * #method
       * scrolls the view to center on the given bp. if that is not in any
       * of the displayed regions, does nothing
       * @param coord - basepair at which you want to center the view
       * @param refName - refName of the displayedRegion you are centering at
       * @param regionNumber - index of the displayedRegion
       */
      centerAt: function centerAt(coord, refName, regionNumber) {
        var centerPx = this.bpToPx({
          refName: refName,
          coord: coord,
          regionNumber: regionNumber
        });
        if (centerPx) {
          self.scrollTo(Math.round(centerPx.offsetPx - self.width / 2));
        }
      },
      /**
       * #method
       */
      pxToBp: function pxToBp(px) {
        return _pxToBp(self, px);
      },
      /**
       * #getter
       */
      get centerLineInfo() {
        return self.displayedRegions.length ? this.pxToBp(self.width / 2) : undefined;
      }
    };
  });
}
export { renderToSvg, RefNameAutocomplete, SearchBox, ZoomControls, LinearGenomeView };
export { default as ReactComponent } from './components/LinearGenomeView';